import { createFileRoute } from "@tanstack/react-router"
import { useState } from "react"

import { StatusAlert } from "@/components/shared/status-alert"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { TablePageSkeleton } from "@/components/ui/page-skeletons"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { useLeaderboardQuery } from "@/hooks/activity-levels"

export const Route = createFileRoute(
  "/_authed/_admin/activity-levels/leaderboard",
)({
  component: ActivityLevelsLeaderboardRoute,
})

function ActivityLevelsLeaderboardRoute() {
  const track = "message" as const
  const [limit, setLimit] = useState(25)
  const leaderboardQuery = useLeaderboardQuery(track, limit)
  const entries = leaderboardQuery.data ?? []

  return (
    <div className="grid gap-4 md:gap-5">
      <Card>
        <CardHeader>
          <CardTitle>Leaderboard</CardTitle>
        </CardHeader>
        <CardContent>
          {leaderboardQuery.isLoading ? (
            <TablePageSkeleton />
          ) : leaderboardQuery.isError ? (
            <StatusAlert tone="danger">
              Failed to load the leaderboard.
            </StatusAlert>
          ) : entries.length === 0 ? (
            <p className="text-sm text-muted-foreground">
              No entries yet for this track.
            </p>
          ) : (
            <div className="grid gap-3">
              <p className="text-sm text-muted-foreground">
                Showing first {entries.length} entries.
              </p>
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Rank</TableHead>
                    <TableHead>Member</TableHead>
                    <TableHead>Level</TableHead>
                    <TableHead>Total XP</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {entries.map((entry) => (
                    <TableRow key={entry.memberId}>
                      <TableCell className="font-medium">
                        {entry.rank}
                      </TableCell>
                      <TableCell>{entry.displayName}</TableCell>
                      <TableCell>{entry.level}</TableCell>
                      <TableCell>{entry.totalXp}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              {entries.length === limit && limit < 100 && (
                <Button
                  variant="outline"
                  onClick={() =>
                    setLimit((current) => Math.min(current + 25, 100))
                  }
                >
                  Load more
                </Button>
              )}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
